import React, { useState } from "react";
import clsx from "clsx";
import { Select } from "antd";
import { getI18n } from "react-i18next";
import {AppFieldWithLabelAndError} from "./AppTypography";

const { Option } = Select;

export const SuffixIcon = ({disabled = false}) => {
  return (
    <svg
    className={`w-5 h-5 ${disabled ? "text-gray-400" : "text-blue-400"}`}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 9l-7 7-7-7"
    />
  </svg>
  );
};

const AppSelect = ({
  label,
  value,
  onChange,
  multiLang = false,
  options = [],
  disabled = false,
  placeholder,
  required = false,
  mandatory = false,
  error,
  className,
  getPopupContainer: getPopupContainerProp,
  dropdownStyle: dropdownStyleProp,
  ...rest
}) => {
  const [isFocused, setIsFocused] = useState(false);
  
  const getKeyAgainstLanguage = () => {
    const lang = getI18n();
    return lang.language == "en" ? "en" : "ar";
  };

  const hasValue = value !== undefined && value !== null && value !== "";

  const handleChange = (selectedValue) => {
    if (onChange) {
      onChange(selectedValue);
    
      // onChange({ target: { value: selectedValue } });
    }
  };

  return (
    <>
      
      <AppFieldWithLabelAndError
      label={label}
      required={required || mandatory}
      error={error}
    >

        <Select
          value={
            value !== undefined && value !== null && value !== ""
              ? value
              : undefined
          }
          onChange={handleChange}
          disabled={disabled}
          placeholder={placeholder}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className={clsx(
            "app-select-custom",
            isFocused && "app-select-focused",
            className
          )}
          dropdownClassName="app-select-dropdown"
          getPopupContainer={
            getPopupContainerProp
              ? getPopupContainerProp
              : () => document.body
          }
          dropdownStyle={{ zIndex: 1100, ...dropdownStyleProp }}
          suffixIcon={<SuffixIcon disabled={disabled}/>
          }
          {...rest}
          >
          {options.map((opt, index) => (
            <Option key={`select-option-${opt.value}-${index}`} className={opt?.className || ""} value={opt.value}>
              {opt.icon && <span className="mr-2">{opt.icon}</span>}
              {multiLang ? opt.label[getKeyAgainstLanguage()] : opt.label}
            </Option>
          ))}
        </Select>
      </AppFieldWithLabelAndError>
    </>
  );
};

export default AppSelect;

